"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.52,14.71a1.17,1.17,0,1,0,1.16,1.16A1.17,1.17,0,0,0,15.52,14.71Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.64,7.43a1.17,1.17,0,1,0-1.16,1.2A1.18,1.18,0,0,0,10.64,7.43Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0ZM7,7.43A2.52,2.52,0,1,1,9.48,10,2.51,2.51,0,0,1,7,7.43ZM9.82,18a.51.51,0,0,1-.32.19H8.92a.34.34,0,0,1-.32-.5L15,5.3a.44.44,0,0,1,.32-.19h.62a.34.34,0,0,1,.32.5Zm5.7.39A2.52,2.52,0,1,1,18,15.87,2.51,2.51,0,0,1,15.52,18.39Z"
  }));
};

exports["default"] = _default;